import { get } from 'lodash';
export var apricot4 = window['useApricot4'] === true ||
    parseInt(get(window, 'cb.apricot.version')) === 4;
